export default function userOrganizationDetailReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_USER_ORGANIZATION_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_USER_ORGANIZATION_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_USER_ORGANIZATION_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}